module.exports = __webpack_public_path__ + "img/5.67175b58.png";